import React, { memo } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import AdvertiserNote from '@/components/Base/AdvertiserNote';

import { Timestamp, TimestampWrapper } from './Timestamp.styles';

function TimestampComponent({ latestTimestamp }) {
  const { formatMessage } = useIntl();

  return (
    <TimestampWrapper>
      <Timestamp>
        {formatMessage({ id: 'timestamp' }, { latestTimestamp })}
      </Timestamp>
      •
      <AdvertiserNote />
    </TimestampWrapper>
  );
}

TimestampComponent.propTypes = {
  latestTimestamp: PropTypes.string.isRequired,
};

export default memo(TimestampComponent);
